<template>
    <div class="bg-white rounded-2xl border border-gray-200 p-4 space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Procès-verbal de réception</p>
            <p class="text-sm text-slate-500 mt-0.5">Ce document valide officiellement la fin des travaux.</p>
        </div>

        <div v-if="!loaded" class="flex items-center gap-2 text-slate-400 py-4">
            <span class="w-4 h-4 border-2 border-slate-300 border-t-blue-500 rounded-full animate-spin" />
            <span class="text-sm">Chargement…</span>
        </div>

        <template v-else>
            <!-- Date de mise en service -->
            <div>
                <label class="text-xs font-semibold text-slate-500 mb-0.5 block">Date de mise en service</label>
                <p class="text-xs text-slate-400 mb-1.5">Date officielle de mise en service de l'appareil.</p>
                <input v-model="form.date_mise_service" type="date" class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" />
            </div>

            <!-- Travaux réservés -->
            <div>
                <label class="text-xs font-semibold text-slate-500 mb-0.5 block">Travaux réservés</label>
                <p class="text-xs text-slate-400 mb-1.5">À renseigner uniquement si des travaux restent à effectuer.</p>
                <div class="flex flex-wrap gap-2 mb-2">
                    <button
                        v-for="preset in travauxPresets"
                        :key="preset"
                        class="px-3 py-1.5 bg-blue-50 text-blue-700 text-xs font-semibold rounded-full hover:bg-blue-100 transition-colors"
                        @click="form.travaux_reserve = preset"
                    >
                        {{ preset }}
                    </button>
                </div>
                <textarea
                    v-model="form.travaux_reserve"
                    class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500 resize-none"
                    rows="3"
                    placeholder="Ex : réglages à finaliser, pièce à remplacer…"
                />
            </div>

            <!-- Observations -->
            <div>
                <label class="text-xs font-semibold text-slate-500 mb-0.5 block">Observations</label>
                <p class="text-xs text-slate-400 mb-1.5">Informations complémentaires sur l'intervention.</p>
                <div class="flex flex-wrap gap-2 mb-2">
                    <button
                        v-for="preset in observationsPresets"
                        :key="preset"
                        class="px-3 py-1.5 bg-blue-50 text-blue-700 text-xs font-semibold rounded-full hover:bg-blue-100 transition-colors"
                        @click="form.observations = preset"
                    >
                        {{ preset }}
                    </button>
                </div>
                <textarea
                    v-model="form.observations"
                    class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500 resize-none"
                    rows="3"
                    placeholder="Ex : fonctionnement validé avec le client…"
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'PvReceptionStep',
    inject: ['wm'],

    data() {
        return {
            loaded: false,
            form: {
                intervention_id:    null,
                travaux_reserve:    '',
                observations:       '',
                date_mise_service:  new Date().toISOString().split('T')[0],
            },
            travauxPresets:      ['Aucun travaux réservés', 'Travaux conformes'],
            observationsPresets: ['Installation conforme', 'Client informé'],
        };
    },

    computed: {
        STORAGE_KEY() { return `intervention:${this.wm.intervention.id}:pv_reception`; },
    },

    watch: {
        form: {
            deep: true,
            handler(val) {
                if (!this.loaded) return;
                try { localStorage.setItem(this.STORAGE_KEY, JSON.stringify(val)); } catch {}
            },
        },
    },

    created() {
        this.loadFromStorage();
    },

    methods: {
        loadFromStorage() {
            this.form.intervention_id = this.wm.intervention.id;
            try {
                const stored = localStorage.getItem(this.STORAGE_KEY);
                if (stored) this.form = { ...this.form, ...JSON.parse(stored) };
            } catch {}
            this.loaded = true;
        },
    },
};
</script>
